import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formValueSelector, change } from 'redux-form';
import { Icon, Dimmer, Loader } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as fileActions from '../store/file/fileActions';

const SIZE_LIMIT = 5 * 1024 * 1024;

class Picture extends PureComponent {
  static propTypes = {
    season: PropTypes.object.isRequired,
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    uploadFile: PropTypes.func.isRequired,
    removeFile: PropTypes.func.isRequired,
    photoName: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    setFileName: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      error: false,
    };
    this.validExt = ['png', 'jpeg', 'jpg', 'gif'];
  }

  onUploadImage = () => {
    this.fileInput.click();
  };

  handleSelectFile = files => {
    this.setState({ error: false });
    if (files && files.length > 0) {
      const file = files[0];
      const fileExt = file.name.match(/\.([^\.]+)$/)[1];
      if (this.validExt.includes(fileExt)) {
        if (file && file.size) {
          if (file.size < SIZE_LIMIT) {
            this.props.setFileName(
              this.props.meta.form,
              'photoName',
              file.name
            );
            this.props.uploadFile(
              file,
              this.props.season.sfId,
              this.props.meta.form,
              this.props.input.name,
              'picture'
            );
          } else {
            this.setState({ error: true });
          }
        }
      } else {
        this.setState({ error: true });
      }
    }
  };

  handleRemoveFile = () => {
    this.props.removeFile(this.props.meta.form, this.props.input.name);
    this.props.setFileName(this.props.meta.form, 'photoName', null);
  };

  renderFileName = () => {
    if (this.props.photoName) {
      return (
        <div className="fileUploadContainerList hasFileUpload">
          <p className="fileUploadName">{this.props.photoName}</p>
          <button
            className="ui circular primary icon button"
            onClick={this.handleRemoveFile}
            style={{ backgroundColor: `#${this.props.season.hexColorCodeC}` }}
          >
            <Icon className="times" />
          </button>
        </div>
      );
    }
  };

  renderRequire = () => (
    <span className="tiny-message error">
      <i>Required.</i>
    </span>
  );

  renderWarning = () => {
    if (this.state.error) {
      return (
        <p className="warning">
          The file you attempted to upload is either not the correct file type
          or is too large.
        </p>
      );
    }
    return '';
  };

  render() {
    const {
      season,
      meta: { touched, invalid },
    } = this.props;
    const fileName = this.renderFileName();
    const error = this.renderWarning();
    return (
      <div>
        <h4
          className="ui dividing header"
          style={{ color: `#${season.hexColorCodeC}` }}
        >
          Submit the picture of the person you are nominating
        </h4>
        {this.props.loading && (
          <Dimmer active inverted>
            <Loader size="large">Loading</Loader>
          </Dimmer>
        )}

        <p>
          Please ensure your image is less than 5MB and in one of the following
          file formats : png, jpeg, jpg, gif
        </p>

        {fileName}

        {error}
        <div className="field" onClick={this.onUploadImage}>
          <label
            style={{ backgroundColor: `#${season.hexColorCodeC}` }}
            htmlFor="fileUpload"
            className="ui fluid huge primary right labeled icon button"
          >
            <Icon className="ui cloud upload" />
            Upload image
          </label>
        </div>
        {touched && invalid && this.renderRequire()}
        <input
          type="file"
          accept="image/png,image/jpeg,image/jpg,image/gif"
          ref={input => {
            this.fileInput = input;
          }}
          className="inputFile"
          onChange={e => this.handleSelectFile(e.target.files)}
        />
      </div>
    );
  }
}

const mapStatesToProps = (state, props) => ({
  photoName: formValueSelector(props.meta.form)(state, 'photoName'),
  loading: state.file.loading,
});

const mapDispatchToProps = dispatch => ({
  uploadFile: (file, seasonId, form, name, type) =>
    dispatch(fileActions.uploadFile(file, seasonId, form, name, type)),
  removeFile: (formName, fieldName) =>
    dispatch(change(formName, fieldName, null)),
  setFileName: (formName, fieldName, value) =>
    dispatch(change(formName, fieldName, value)),
});

export default connect(mapStatesToProps, mapDispatchToProps)(Picture);



// WEBPACK FOOTER //
// ./src/components/Picture.js